import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import LocationSelect from "../../location/locationselect.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
const uuidv4 = require('uuid/v4')

class InlineEditLocation extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            location: this.props.value,
            locationId: this.props.locationId,
            endPoint: this.props.endPoint || '',
            field: this.props.field || 'locationId',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            success: false,
        }
        this.handleUserSelectChange = this.handleUserSelectChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        const defaultCallback = () => { }
        this.onSave = this.props.onSave || defaultCallback
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            location: nextProps.value,
            locationId: nextProps.locationId,
            endPoint: nextProps.endPoint || '',
            field: nextProps.field || 'locationId',
            editable: nextProps.editable || false,
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleUserSelectChange(locationId) {
        this.setState({
            locationId: locationId,
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
        })
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: this.state.locationId,
        }).then((r) => {
            this.setState({
                location: r.attributes.location.attributes.name,
                editMode: false,
                isLoading: false,
                success: !r.error,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1500)
            })
            this.onSave(this.state)
        })
    }

    render() {
        let location = this.state.location
        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {location} {!this.state.success ? <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'} className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />}
            </a>
            location = <span>
                {link}
                <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')} style={{ width: '350px' }}>
                    <div className="w-100 m-0">
                        <LocationSelect
                            value={this.state.locationId}
                            onChange={this.handleUserSelectChange}
                            className="form-control"
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={this.save}
                            isLoading={this.state.isLoading}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        }

        return location ? location : null
    }

}

export default InlineEditLocation





// WEBPACK FOOTER //
// ./src/common/inline-edit/location.component.jsx